import api from "./api";
import * as actionTypes from "./actionTypes";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import * as eventTypes from "./eventTypes";

export function loadLeasingExpenses(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    let loading = false,
      loaded = false;
    let leasingExpenses = getState().currentOffer.leasingExpenses[key];
    if (leasingExpenses) {
      loading = leasingExpenses.loading;
      loaded = leasingExpenses.loaded;
    }
    if (loading || loaded) return;
    dispatch({ type: actionTypes.LOAD_LEASING_EXPENSES_STARTED });
    try {
      leasingExpenses = await dispatch(sendHttpRequest(api.getLeasingExpenses(documentId, siteId)));
      const payload = leasingExpenses.map(x => {
        return { ...x, key: `${x.documentId}-${x.siteId}-${x.leasingExpenseId}` };
      });
      dispatch({ type: actionTypes.LOAD_LEASING_EXPENSES_SUCCESS, payload: payload, id: key });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_LEASING_EXPENSES_FAILED, payload: { documentId, siteId, error } });
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateLeasingExpenses(documentId, siteId, leasingExpenses, callback) {
  return async dispatch => {
    try {
      await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.updateLeasingExpenses(documentId, siteId, leasingExpenses),
          "updateLeasingExpensesCommand",
          [eventTypes.LEASING_EXPENSES_UPDATED]
        )
      ).then(event => {
        if (event.ok) {
          dispatch({ type: actionTypes.LEASING_EXPENSES_UPDATED });
        }
        callback();
        return event;
      });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
